<div class="wetter_content_container">
  <div>
    <h3>Kurzwettervorhersage</h3>
    <div class="bericht-text-container">
      <div
        class="bericht-text-sub-label">{{berlinBrandenburgKurzBericht?.kurzwetterVorhersage?.tag00?.datum | date: 'EEE dd.MM'}}</div>
      <p>{{berlinBrandenburgKurzBericht?.kurzwetterVorhersage?.tag00?.kurzbeschreibung}}</p>
    </div>
    <div class="bericht-text-container">
      <div
        class="bericht-text-sub-label">Nacht zu {{berlinBrandenburgKurzBericht?.kurzwetterVorhersage?.nachtZuTag01?.datum | date: 'EEE dd.MM'}}</div>
      <p>{{berlinBrandenburgKurzBericht?.kurzwetterVorhersage?.nachtZuTag01?.kurzbeschreibung}}</p>
      <div
        class="bericht-text-sub-label">{{berlinBrandenburgKurzBericht?.kurzwetterVorhersage?.tag01?.datum | date: 'EEE dd.MM'}}</div>
      <p>{{berlinBrandenburgKurzBericht?.kurzwetterVorhersage?.tag01?.kurzbeschreibung}}</p>
    </div>
    <div class="bericht-text-container">
      <div class="bericht-text-sub-label">5-Tage Aussichten</div>
      <p>{{berlinBrandenburgKurzBericht?.kurzwetterVorhersage?.aussichten_5Tage}}</p>
    </div>
  </div>
</div>
